import React from 'react';
import { Typography } from '@saucelabs/ds-typography';
import { Button } from '@saucelabs/ds-button';

import { Card } from '../../Layout/Card';
import Styles from './AdditionalPlanTile.styles';
import { trackEvent, EVENTS } from '../../../tracking';
import OpenSauceIcon from './open-sauce-icon.svg';

const OpenSauceTile: React.FC = () => (
  <Card
    className={`${Styles['plan-tile']} px-2.5 py-3 m-1 flex flex-col shadow-sm`}
  >
    <div className="flex flex-row justify-center">
      <OpenSauceIcon className={`${Styles['tile-icon']} my-0.5`} />
    </div>
    <Typography
      className="text-center font-bold"
      disableSpacing
      variant="heading-4"
    >
      Open Sauce & COVID-19
    </Typography>
    <p className="text-gray-600 my-2 mb-5 leading-7 text-center">
      Sauce Labs is committed to supporting open source and COVID-19 projects,
      with free accounts for qualifying initiatives.
    </p>

    <div className="flex items-end flex-row-reverse mt-auto">
      <Button
        color="primary"
        onClick={() => {
          trackEvent(EVENTS.CONTACT_OSS);
          window.open('https://saucelabs.com/open-sauce', '_blank');
        }}
        variant="text"
      >
        Get Open Sauce
      </Button>
    </div>
  </Card>
);

export { OpenSauceTile };
